module.exports = __webpack_public_path__ + "static/media/alena_thumb.242bb4a1.jpg";